module.exports = __webpack_public_path__ + "img/tiktok-logo-white.229768f3.svg";